import { cn } from "@/lib/cn"

// Rounded-square first-letter avatar, brand-red gradient. Used in list
// rows (skills, tickets) where one row represents a thing and we want a
// quick visual anchor on the left.
type Props = {
  name: string
  src?: string | null
  className?: string
}

export function RowAvatar({ name, src, className }: Props) {
  const initial = (name.trim()[0] ?? "?").toUpperCase()
  if (src) {
    return (
      <img
        src={src}
        alt={initial}
        loading="lazy"
        className={cn(
          "h-10 w-10 shrink-0 rounded-control object-cover bg-app-panel2",
          className,
        )}
      />
    )
  }
  return (
    <div
      className={cn(
        "flex h-10 w-10 shrink-0 items-center justify-center rounded-control bg-gradient-to-br from-brand-red to-brand-redDeep font-semibold text-white shadow-redGlow",
        className,
      )}
    >
      {initial}
    </div>
  )
}
